import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';

import { CURRENCY_CODES } from '../constants';
import { currencyCodeChange } from '../actions/currencyExchangeRates';

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, ownProps) => ({
  currencyCode: state.currencyExchangeRates.currencyCode,
});

// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch, ownProps) => ({
  onCurrencyCodeChange: currencyCode => dispatch(currencyCodeChange(currencyCode)),
});

export class CurrencySelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };

    this.toggleSelector = this.toggleSelector.bind(this);
    this.handleCurrencyCodeChange = this.handleCurrencyCodeChange.bind(this);
  }

  handleClickOutside() {
    this.setState({ open: false });
  }

  toggleSelector() {
    const { open } = this.state;
    this.setState({ open: !open });
  }

  handleCurrencyCodeChange(event) {
    this.props.onCurrencyCodeChange(event.target.value);
    this.toggleSelector();
  }

  render() {
    const { currencyCodes } = this.props;
    const buttonClass = this.state.open ? 'close' : 'open';

    const listItems = currencyCodes.map(currencyCode => (
      <li className={currencyCode === this.props.currencyCode ? ' active' : ''} key={currencyCode}>
        <button
          className={currencyCode}
          value={currencyCode}
          onClick={this.handleCurrencyCodeChange}
        >
          {currencyCode}
        </button>
      </li>
    ));

    return (
      <div className="currency-selector">
        <span>Default Currency:</span>
        <button
          title="Change Currency"
          className={`toggle ${buttonClass} ${this.props.currencyCode}`}
          onClick={this.toggleSelector}
        >
          {this.props.currencyCode}
        </button>
        {this.state.open ? <ul>{listItems}</ul> : null}
      </div>
    );
  }
}

CurrencySelector.defaultProps = {
  currencyCode: CURRENCY_CODES[0],
  currencyCodes: CURRENCY_CODES,
  onCurrencyCodeChange: () => {},
};

CurrencySelector.propTypes = {
  currencyCode: PropTypes.string,
  currencyCodes: PropTypes.arrayOf(PropTypes.string),
  onCurrencyCodeChange: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(onClickOutside(CurrencySelector));



// WEBPACK FOOTER //
// ./src/components/CurrencySelector.js